module.exports = __webpack_public_path__ + "img/phone.5ba6beb8.svg";